<template>
        <div class="client-box">
         <!-- 面包屑 -->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>库存管理</el-breadcrumb-item>
            <el-breadcrumb-item>往来单位</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 顶部栏 -->
        <div class="header-bar">
            <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item v-if="addRule">
                    <el-button @click="add" type="primary" size="small" icon="el-icon-plus">添加</el-button>
                </el-form-item>
                <el-form-item label="来往单位">
                     <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="margin" @click="search" icon="el-icon-search" size="small">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="pro-con">
            <!-- table -->
            <el-table
            border
            v-loading="loading"
            :data="list"
            style="width: 100%">
                <el-table-column
                    prop="name"
                    label="名称">
                </el-table-column>
                <el-table-column
                    prop="type"
                    label="类型">
                    <template slot-scope="scope">
                        {{scope.row.type==0?'供应商':'客户 | 领用人 '}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="mobile"
                    label="电话">
                </el-table-column>
                <el-table-column
                    prop="address"
                    label="地址">
                </el-table-column>
                <el-table-column
                    prop="remark"
                    label="备注">
                </el-table-column>
                <el-table-column
                width="100"
                fixed="right"
                v-if="editRule"
                label="操作">
                    <template slot-scope="scope">
                        <i class="edit el-icon-delete-solid" @click="handleDelete(scope.row.id)"></i>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- content-end -->
        <!-- 分页 -->
        <div class="block">
            <el-pagination
                 @current-change="changePage"
                layout="prev, pager, next"
                :page-size="pageSize"
                :total="totalPage">
            </el-pagination>
        </div>
        <!-- 添加仓库 -->
        <el-dialog title="添加往来单位" 
        :visible.sync="drawer">
            <AddRelatedParty @addSuc="addSuc"/>
        </el-dialog>

    </div>
</template>
<script>
import {checkRules} from '@/utils/util.js'
import AddRelatedParty from '@/components/AddRelatedParty'
export default {
    components:{
        AddRelatedParty
    },
    data(){
        return{
            addRule:checkRules(11),
            editRule:checkRules(0),
            drawer:false,
            list:[],
            loading:false,
            page:1,
            totalPage:0,
            pageSize:10,
            form:{
                warehouse:""
            }
        }
    },
    created(){
        this.searchRelatedParty()
    },
    methods:{
        //切换页码
        changePage(page){
            //console.log(page)
            this.page = page 
            this.search()
        },
        search(){
            this.page = 1
           // console.log('搜索')
            this.searchRelatedParty()
        },
        //删除
        handleDelete(id){
            this.$confirm(this.CONST.DEL_CONFIRM, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                        let params = {
                            method:"delrelatedParty",
                            id
                        }
                        this.loading = true
                    this.$ajax.post(this.API.api,params).then(()=>{
                        this.loading = false 
                            this.$message({
                                message: this.CONST.DEL_SUC,
                                type: 'success'
                            });
                            //刷新
                            this.search()
                    }).catch(err=>{
                        this.loading = false 
                            this.$message({
                                message: err.msg?err.msg:err,
                                type: 'warning'
                            });
                    })  
                }).catch(err=>{
                    this.$message({
                        type: 'info',
                        message: err.msg||this.CONST.DEL_CANCEL
                    });      
                })
        },
        //添加
        add(){
            this.drawer = true
        },
        addSuc(){
            this.drawer = false
            this.searchRelatedParty()
        },
        //搜索仓库
        searchRelatedParty(){
            let form = this.form
            form.method = "getRelatedParty"
            form.page = this.page 
            form.pageSize = this.pageSize
            console.log(form)
            this.loading = true
            this.$ajax.post(this.API.api,form).then(res=>{
                this.loading = false 
                if(res.data){
                    console.log(res)
                    this.list = res.data.list
                    this.totalPage = res.data.totalPage
                }

            }).catch(err=>{
                console.log(err)
                this.loading = false 
                this.$message({
                    message: err.msg?err.msg:err,
                    type: 'warning'
                });
            })
        },
        //选择仓库
        select(){

        }
    }
}
</script>
<style lang="less">

</style>